import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { useAuthStore } from '../store/auth-store';
const fallbackColors = [
    'bg-blue-500', 'bg-green-500', 'bg-purple-500', 'bg-orange-500', 'bg-pink-500',
    'bg-teal-500', 'bg-indigo-500', 'bg-red-500',
];
function getColor(name) {
    let hash = 0;
    for (let i = 0; i < name.length; i++)
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
    return fallbackColors[Math.abs(hash) % fallbackColors.length];
}
function getInitials(name) {
    return name.replace('@', '').split(' ').map((n) => n[0]).join('').toUpperCase().slice(0, 2);
}
export function Avatar({ userId, name, avatarUrl: overrideAvatarUrl, size = 'w-8 h-8', className = '' }) {
    const users = useAuthStore((s) => s.users);
    const currentUser = useAuthStore((s) => s.user);
    const [imageError, setImageError] = useState(false);
    let matchedUser;
    if (userId) {
        matchedUser = users.find((u) => u.id === userId);
        if (!matchedUser && currentUser?.id === userId) {
            matchedUser = currentUser;
        }
    }
    if (!matchedUser && name) {
        const lookupName = name.replace('@', '');
        matchedUser = users.find((u) => u.username === lookupName || u.displayName === lookupName);
    }
    const avatarUrl = overrideAvatarUrl || matchedUser?.avatarUrl || '';
    const displayName = matchedUser?.displayName || name || 'U';
    const initials = getInitials(displayName);
    const handleImageError = () => {
        setImageError(true);
    };
    if (imageError || !avatarUrl) {
        return (_jsx("div", { className: `${size} rounded-full flex items-center justify-center text-white text-sm font-medium overflow-hidden flex-shrink-0 ${getColor(displayName)} ${className}`, children: initials }));
    }
    return (_jsx("div", { className: `${size} rounded-full flex items-center justify-center text-white text-sm font-medium overflow-hidden flex-shrink-0 ${className}`, children: _jsx("img", { src: avatarUrl, alt: `${displayName}'s avatar`, className: "w-full h-full object-cover", onError: handleImageError }) }));
}
//# sourceMappingURL=Avatar.js.map